import angular from 'angular';
import uiRouter from 'angular-ui-router';
import DashboardMovementsComponent from './movements.component';

const dashboardMovementsModule = angular.module('tinaba.components.dashboard.movements', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('dashboard.movements', {
      url: '/movements',
      template: '<dashboard-movements></dasboard-movements>'
    });
})

.component('dashboardMovements', DashboardMovementsComponent);

export default dashboardMovementsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/movements/movements.js
 **/